import { EventType } from "./enums/eventType.enum";
import { User } from "./user.model";
import { Reason } from "./reason.model";

export class TicketEvent {

    public id: number;
    public ticketId: number;
    public description: string;
    public reason: Reason;
    public eventAuthor: User;
    public eventDate: Date;
    public eventType: EventType;


    constructor(ticketEvent: any = {}) {
        this.id = ticketEvent.id || null;
        this.ticketId = ticketEvent.ticketId || null;
        this.description = ticketEvent.description || '';
        this.reason = ticketEvent.reason ? new Reason(ticketEvent.reason) : null;
        this.eventAuthor = ticketEvent.eventAuthor;
        this.eventDate = ticketEvent.eventDate;
        this.eventType = ticketEvent.eventType || EventType.Pause;
    }

    get type() {
        return 'ticketEvent';
    }
}
